<template>
  <v-dialog
    v-model="dialog"
    width="500"
  >
    <v-card class="flex-column d-flex pa-7 pt-10 pb-20">
      <div class="d-flex align-center justify-center ml-2 mr-2 mb-2">
        <v-img src="/img/alert/icon-modal-renew.svg" style="max-width: 80px"></v-img>
        <div v-if="!user.trial_active" class="ml-8 d-flex flex-column">
          <div class="red--text" style="font-size: 1.3em;">
            <span>Faltam {{remainingDays}} dias para a renovação do seu plano, <strong>{{firstname}}</strong>!</span>
          </div>
          <div class="mt-3 mb-3 grey--text text--darken-1">
            <div>Evite que seus links parem.</div>
            Continue criando e gerenciando seus links, mantendo-os organizados e efetivos. Para isso, basta escolher um dos nossos planos. 
          </div>
          <v-btn class="mt-5" style="width: 200px" depressed color="green darken-2" @click="toPlan()" dark>Renovar plano</v-btn>
        </div>
        <div v-else class="ml-8 d-flex flex-column">
          <div class="red--text" style="font-size: 1.3em;">
            <span v-if="remaining === 'today'">Hoje é o último dia do seu período de teste, </span>
            <span v-else-if="remaining === 'tomorrow'">Amanhã é o último dia do seu período de teste, </span>
            <span v-else-if="remainingDays > 0">Faltam {{remainingDays}} dias para finalizar o seu período de teste, </span>
            <span v-else>Você não possui um plano ativo, </span>
            <strong>{{firstname}}</strong>!
          </div>
          <div class="mt-3 mb-3 grey--text text--darken-1">
            Continue criando e gerenciando seus links, mantendo-os organizados e efetivos. Para isso, basta escolher um dos nossos planos. 
          </div>
          <v-btn class="mt-5" style="width: 200px" depressed color="green darken-2" @click="toPlan()" dark>Ativar plano</v-btn>
        </div>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import moment from 'moment'
import { mapState } from 'vuex'

export default {
  data () {
    return {
      dialog: false
    }
  },
  computed: {
    ...mapState({
      user: state => state.auth.user
    }),
    firstname () {
      return this.user.name.split(' ')[0]
    },
    icon () {
      let src = null

      if (this.type === 'domain') {
        src = '/img/alert/upgrade-domain.svg'
      } else {
        src = '/img/alert/upgrade-plan.svg'
      }

      return src
    },
    remainingDays () {
      return Math.round(moment(this.user.active_plan_at).diff(moment(), 'days', true))
    },
    remaining () {
      if (moment(this.user.active_plan_at).format('DD/MM/YYYY') === moment().format('DD/MM/YYYY')) {
        return 'today'
      }

      if (moment(this.user.active_plan_at).format('DD/MM/YYYY') === moment().add(1, 'days').format('DD/MM/YYYY')) {
        return 'tomorrow'
      }

      return Math.round(moment(this.user.active_plan_at).diff(moment(), 'days', true))
    }
  },
  watch: {
    user: {
      immediate: true,
      handler: function (user) {
        if (user && user.active_plan_at) {
          this.dialog = user.trial_active ? this.remainingDays <= 3 : this.remainingDays <= 7 
        }
      }
    }
  },
  methods: {
    toPlan () {
      this.dialog = false
      this.$router.push('/plano?show=true')
    }
  }
}
</script>

<style lang="scss" scoped>

</style>